export const roles = {
  CLIENT: "CLIENT",
  BUSINESS: "BUSINESS",
  STAFF: "STAFF",
};

export const isBusiness = (role) => role === roles.BUSINESS.toLowerCase();
export const isStaff = (role) => role === roles.STAFF.toLowerCase();
export const isClient = (role) => role === roles.CLIENT.toLowerCase();
